import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-forbidden-error',
    templateUrl: './forbidden-error.component.html',
    styleUrls: ['./forbidden-error.component.scss'],
})
export class ForbiddenErrorComponent {
    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        const url = this.route.snapshot.paramMap.get('url');
    }
}
